<template>
    <div class="alarm-rule">
        <div class="alarm-rule-con">
            <div v-if="data && data.length > 0"
                 class="icon">
                <i class="icon-alarm-list-o"></i>
            </div>
            <div class="content">
                <div v-for="(d, index) in data"
                     :key="index"
                     class="content-item"
                     style="border-bottom: 1px dashed #e9e9e9;">
                    <p class="title">
                        <span>
                            <span style="color: #999;">告警规则：</span>
                            {{d.name}}
                        </span>
                        <!-- <span v-if="!isLocak"
                              @click="deletById(d.id)"
                              class="icon-span">
                            <i class="icon-delete"></i>
                        </span> -->
                    </p>
                    <div style="padding: 0px 10px;">
                        <p v-for="(item, key) in d.alarmRuleStrategies"
                           :key="key">
                            <span class="info">
                                <span style="color: #999;">告警策略：</span>
                                {{item.content || '--'}}
                            </span>
                        </p>
                    </div>

                </div>
                <div v-if="!data || data.length === 0"
                     class="no-data">
                    <nodata value="没有查询到相关数据" />
                </div>
            </div>
            <alarmtemplate ref="alarmtemplate"></alarmtemplate>
        </div>
    </div>
</template>

<script>
import API from '@/service/api'
import nodata from '@c/basic/nodata'
import alarmtemplate from './alarmtemplate'
export default {
    name: 'alarmRule',
    props: {
        isNoPer: {
            type: Function
        },
        isLocak: {
            type: Boolean
        },
        nowRow: {
            type: Object
        }
    },
    components: {
        alarmtemplate,
        nodata
    },
    data () {
        return {
            data: []
        }
    },
    created () {
        this.init()
    },
    watch: {
        'nowRow' () {
            this.init()
        }
    },
    methods: {
        init () {
            this.axios.get(this.urlFormat(API.GET_ALARM_RESID, true, [this.$route.params.id])).then(res => {
                if (!res.code || !res.status) {
                    this.data = res
                } else {
                    this.data = []
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.alarm-rule {
    padding: 15px 10px;
    height: 189px;
    .alarm-rule-con {
        display: flex;
        height: 100%;
        overflow-y: auto;
    }
    .icon {
        width: 50px;
        height: 50px;
        min-width: 50px;
        text-align: center;
        line-height: 50px;
        border-radius: 50%;
        border: 1px solid #e9e9e9;
        font-size: 35px;
        color: #efa749;
        margin-right: 25px;
    }
    .content {
        flex-grow: 1;
        position: relative;
        top: -10px;
        .title {
            padding: 10px 0px;
        }
        p {
            display: flex;
            justify-content: space-between;
            padding: 10px 5px;
            .icon-span {
                position: relative;
                padding: 0px 10px;
                cursor: pointer;
                color: #888;
                &::after {
                    content: "";
                    height: 60%;
                    display: inline-block;
                    position: absolute;
                    top: 20%;
                    right: 0px;
                    border-right: 2px solid #cfcfcf;
                }
                &:last-child {
                    position: relative;
                    left: -10px;
                    &::after {
                        display: none;
                    }
                }
                i:hover {
                    color: #1f68b3;
                }
            }
        }
        .no-data {
            text-align: center;
        }
        .content-item:last-child {
            border-bottom: none !important;
            p:last-child {
                padding-bottom: 0px;
            }
        }
    }
}
</style>
